import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = resource => {
  return [
    <MenuItem
      primaryText='Edit'
      key='edit'
      value={`/ecommerce/orders/${resource.order_id}/items/${resource.id}/edit`}
    />,
    <MenuItem
      primaryText='Product'
      key='product'
      value={`/ecommerce/products/${resource.product_id}/edit`}
    />
  ]
}

export default buildMenuItems
